import { Button, Icon } from '@chakra-ui/react'
import { Eye, EyeOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface IncludeDisabledFilterProps {
  includeDisabled: boolean
  onToggle: () => void
}

export function IncludeDisabledFilter({
  includeDisabled,
  onToggle,
}: IncludeDisabledFilterProps) {
  const { t } = useTranslation()

  return (
    <Button
      aria-label="Toggle include disabled clusters"
      onClick={onToggle}
      height={6}
      size="sm"
      pl={2}
      py={2}
      variant={includeDisabled ? 'solid' : 'outline'}
      colorPalette={includeDisabled ? 'blue' : 'gray'}
      borderColor={includeDisabled ? 'blue.500' : 'gray.300'}
      data-testid="include-disabled-filter"
    >
      <Icon as={includeDisabled ? Eye : EyeOff} />
      {includeDisabled
        ? t('clusterConfigTable.filters.includingDisabled')
        : t('clusterConfigTable.filters.excludingDisabled')}
    </Button>
  )
}
